module.exports = __webpack_public_path__ + "static/media/monitor.c9164c96.png";